import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type BzBadgeTone = 'neutral' | 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger';

/**
 * A small count or status indicator, meant to sit on the corner of an icon
 * or avatar. Solid background, unlike `bz-tag`'s tint — a badge has to read
 * at a glance against arbitrary content behind it, where a tint would wash
 * out.
 *
 * `dot` drops the projected content for a plain notification dot: for "there
 * is something new", not "there are 3 somethings".
 */
@Component({
  selector: 'bz-badge',
  templateUrl: './bz-badge.html',
  styleUrl: './bz-badge.scss',
  host: {
    '[class]': 'hostClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzBadge {
  readonly tone = input<BzBadgeTone>('danger');
  readonly dot = input(false);

  protected readonly hostClass = computed(
    () => `bz-badge bz-badge--${this.tone()} ${this.dot() ? 'bz-badge--dot' : ''}`,
  );
}
